import React from 'react'
import PrimaryLayout from '../components/layout/PrimaryLayout'

const Logs: React.FC = () => {
    return (
        <PrimaryLayout>

            <h1>Logs</h1>

        </PrimaryLayout>
    )
}

export default Logs